import { BookingTransactionStatus } from './constants/booking-transaction-constants';

interface StatusType {
    buyerInvoiceStatusGroup: {label: string};
}

const getDisplayValue = (value: string | number ): string | number => {
    const status: StatusType = BookingTransactionStatus[value];
    return status ? status.buyerInvoiceStatusGroup.label : value;
};

export default getDisplayValue;